import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import BottomDrawer from "../../../../../../../../components/WMS/Mobile/BottomDrawer";
import {Grid} from "@mui/material";
import {FormattedMessage} from "react-intl";
import CustomButton from "../../../../../../../../components/CustomButton";
import {ReactComponent as BoxOutlinedIcon} from 'assets/img/wms/boxOutlinedIcon.svg';
import {ReactComponent as PrinterIcon} from 'assets/img/wms/printerIcon.svg'
import {ReactComponent as ScanIcon} from 'assets/img/wms/scanIcon.svg'
import {WMSContext} from "../../../../../../context/WMSContext";

PackingActionDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedAction: PropTypes.func.isRequired
};

function PackingActionDrawer({open, onClose, selectedAction}) {
    const {currentOrganization} = useContext(WMSContext)

    return (
        <BottomDrawer
            open={open}
            onClose={onClose}
            openMaxHeight
            maxHeight={"50%"}
            title={<FormattedMessage id={"wms.packing.actionDrawer.title"}/>}
            subtitle={<FormattedMessage id={"wms.packing.actionDrawer.subtitle"}/>}
        >
            <Grid container direction={"column"} gap={"22px"} sx={{padding: "8px"}}>
                <CustomButton
                    color={"default"}
                    variant={"nude"}
                    onClick={() => selectedAction("specialOrder")}
                    fullWidth
                    contentJustify={"left"}
                >
                    <BoxOutlinedIcon style={{marginRight: "8px", width: "18px", height: "18px"}} />
                    <FormattedMessage id={"wms.packing.action.specialOrderButton.title"}/>
                </CustomButton>
                <CustomButton
                    color={"default"}
                    variant={"nude"}
                    onClick={() => selectedAction("printer")}
                    fullWidth
                    contentJustify={"left"}
                >
                    <PrinterIcon style={{marginRight: "8px", width: "18px", height: "18px"}} />
                    <FormattedMessage id={"wms.packing.action.printerConfigButton.title"}/>
                </CustomButton>

                {!currentOrganization?.forcePackingStationScan && (
                    <CustomButton
                        color={"default"}
                        variant={"nude"}
                        onClick={() => selectedAction("packingStation")}
                        fullWidth
                        contentJustify={"left"}
                    >
                        <ScanIcon style={{marginRight: "8px", width: "18px", height: "18px"}} />
                        <FormattedMessage id={"wms.packing.action.packingStationScanButton.title"}/>
                    </CustomButton>
                )}
            </Grid>
        </BottomDrawer>
    );
}

export default PackingActionDrawer;